import React from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';

/**
 * Los límites honestos de «Hacer sonar», TAL CUAL los fija la spec (§5.2):
 * sin push ni MDM, una página web no puede más. Se le dicen a quien pulsa el
 * botón para que no confíe en él para algo que no hace.
 */
export const LIMITES_SONAR: { titulo: string; texto: string }[] = [
  {
    titulo: 'Sólo con la app abierta y la pantalla encendida.',
    texto:
      'Con la pantalla apagada o la app en segundo plano, Chrome congela la página: no corre JavaScript y el aviso no se procesa hasta que la pantalla vuelve. Si para entonces llega, suena en ese momento.',
  },
  {
    titulo: 'Sólo si alguien tocó la pantalla desde que la app se cargó.',
    texto:
      'Chrome exige «activación de usuario» para reproducir audio y para vibrar. En un equipo de piso en uso casi siempre se cumple. Después de una recarga sin ningún toque, el navegador bloquea el sonido y sólo aparece el aviso visual (resultado «bloqueado»).',
  },
  {
    titulo: 'Con el volumen al mínimo o en silencio, no suena.',
    texto: 'No hay forma de saltarse eso desde una página web.',
  },
  {
    titulo: 'Sin red, no llega.',
    texto:
      'El aviso no se encola: si el equipo está desconectado, la respuesta dice que no se entregó.',
  },
  {
    titulo: 'No localiza.',
    texto:
      'Sirve para encontrar un equipo dentro de la tienda (bajo una caja, en bodega), no para saber dónde está.',
  },
];

interface Props {
  visible: boolean;
  onHide: () => void;
}

export const AyudaSonarDialog: React.FC<Props> = ({ visible, onHide }) => (
  <Dialog
    header="«Hacer sonar»: lo que sí y lo que no"
    visible={visible}
    onHide={onHide}
    className="disp-overlay"
    style={{ width: '560px', maxWidth: 'calc(100vw - 32px)' }}
    footer={<Button label="Entendido" onClick={onHide} autoFocus />}
  >
    <p className="disp-ayuda-intro">
      La app abre un aviso a pantalla completa con el código del equipo, repite un sonido y vibra
      durante 20 segundos o hasta que alguien toque la pantalla.
    </p>
    <ul className="disp-ayuda-lista" data-testid="ayuda-sonar">
      {LIMITES_SONAR.map((l) => (
        <li key={l.titulo}>
          <strong>{l.titulo}</strong> {l.texto}
        </li>
      ))}
    </ul>
  </Dialog>
);
